import axios from 'axios';

interface Response {
  ret?: number;
  msg?: string;
  result?: Record<string, any>;
}

// TODO: 待重构
export function commCgi<T>(
  name: string,
  params: Record<string, any> = {},
): Promise<T & Response> {
  return axios
    .get('//vip.video.qq.com/fcgi-bin/comm_cgi', {
      params: { name, otype: 'xjson', ...params },
      withCredentials: true,
    })
    .then((response) => {
      const data = response.data as Response;
      if (typeof data.ret === 'number') {
        if (data.ret === 0) {
          return data as any;
        }
        const err = new Error(`${data.msg}(${data.ret})`);
        (err as any).code = data.ret;
        (err as any).msg = data.msg;
        (err as any).res = data;
        throw err;
      } else {
        // 没有ret 交给业务判断
        return data;
      }
    });
}
